module.exports = __webpack_public_path__ + "img/18.79f8549f.png";